import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {CreateDepositService} from '../../../../services/apiServices/business/create-deposit.service';
import {TranslateService} from '@ngx-translate/core';
import {CommonService} from '../../../../services/apiServices/business/common.service';

@Component({
  selector: 'app-signature-options',
  templateUrl: './signature-options.component.html',
  styleUrls: ['./signature-options.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignatureOptionsComponent implements OnInit {
  @ViewChild('customPreviewContainer', {static: false})
  customPreviewContainer: ElementRef;
  @ViewChild('sigContainer', {static: false})
  sigContainer: ElementRef;
  @Output()
  public stored: EventEmitter<boolean>;
  @Input()
  public pagesImages: any;
  @Input()
  public signature: File;
  @Input()
  public depositDir: string;
  @Input()
  pageCount: number;
  @Input()
  public sigPages: any[];
  @Input()
  public pages: any[];
  sigContainerStyle: any;
  sigPosX: number;
  sigPosY: number;
  sigWidth: number;
  sigHeight: number;
  sigCWidth: number;
  sigCHeight: number;
  selectedCustomizationPage: number;
  selectedSignaturePage: number;
  customizeContainerBGStyle: any;
  constructor(private createDepositService: CreateDepositService, private commonService: CommonService,
              private translate: TranslateService) {
    this.stored = new EventEmitter<boolean>();
  }

  ngOnInit() {
    this.selectedSignaturePage = 1;
    setTimeout(() => {
    this.updateCustomizationViewer({page: 0});
    const sigUrl = URL.createObjectURL(this.signature);
    const sigContainerWidth = this.customPreviewContainer.nativeElement.getBoundingClientRect().width;
    const sigContainerHeight = this.customPreviewContainer.nativeElement.getBoundingClientRect().height;
    this.sigContainerStyle = {
      left: (140 * sigContainerWidth / 210) + 'px',
      top: (255 * sigContainerHeight / 297) + 'px',
      width: '70px',
      height: '70px',
      'background-image': 'url(' + sigUrl + ')',
      'background-size': 'cover',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'background-color': 'white'
    };
    setTimeout(() => {
      this.recalculateSigPosition();
    }, 500);
    }, 500);
  }
  public updateCustomizationViewer(pagination) {
    this.selectedCustomizationPage = pagination.page + 1;
    if (this.pagesImages.hasOwnProperty('page_' + this.selectedCustomizationPage)) {
      this.customizeContainerBGStyle = {
        'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_' + this.selectedCustomizationPage] + ')'
      };
    } else {
      if (this.depositDir) {
        this.createDepositService.getPageAsImage(this.depositDir, this.selectedCustomizationPage).subscribe(response => {
          this.pagesImages['page_' + this.selectedCustomizationPage] = response['page_' + this.selectedCustomizationPage];
          this.customizeContainerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_' + this.selectedCustomizationPage] + ')'
          };
        });
      }
    }
  }
  public recalculateSigPosition(): void {
    this.sigPosX = this.sigContainer.nativeElement.getBoundingClientRect().left - this.customPreviewContainer.nativeElement.getBoundingClientRect().left;
    this.sigPosY = this.sigContainer.nativeElement.getBoundingClientRect().top - this.customPreviewContainer.nativeElement.getBoundingClientRect().top;
    this.sigWidth = this.sigContainer.nativeElement.getBoundingClientRect().width;
    this.sigHeight = this.sigContainer.nativeElement.getBoundingClientRect().height;
    this.sigCWidth = this.customPreviewContainer.nativeElement.getBoundingClientRect().width;
    this.sigCHeight = this.customPreviewContainer.nativeElement.getBoundingClientRect().height;
  }
  public storeSignaturePosition() {
    const area = {
      page: this.selectedSignaturePage,
      posX: this.sigPosX * 210 / this.sigCWidth,
      posY: this.sigPosY * 297 / this.sigCHeight,
      width: this.sigWidth * 210 / this.sigCWidth,
      height: this.sigHeight * 297 / this.sigCHeight,
    };
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('area', JSON.stringify(area));
    this.createDepositService.storeSignaturePosition(dataToSend).subscribe(response => {
      if (response.depositDir) {
        this.stored.emit(true);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

}
